import React from 'react';
import { showAsRequired } from '@jsonforms/core';
import merge from 'lodash/merge';
import { ControlProps } from '../../types/controlProps';
import { useVisibilityLevelContext } from '../../contexts/VisibilityLevelContext';
import { MantineInputWrapper } from '../complex';
import { getDefaultValue, useSelectedObject } from '../../hooks/useSelectedObject';
import { useIsParentSelected } from '../../hooks/useIsParentSelected';

export interface WithInput {
  input: any;
}

export const MantineInputControl = (props: ControlProps & WithInput) => {
  const { isLevelEnabled } = useVisibilityLevelContext();
  const { isParentSelected } = useIsParentSelected(props.path);
  const disabled = !isParentSelected;
  const fallbackValue = disabled ? '' : getDefaultValue(props.path);

  const { id, description, errors, label, uischema, visible, required, config, input, data } = props;

  const propertyLevel = props.schema.level;
  const isValid = errors?.length === 0;
  const appliedUiSchemaOptions = merge({}, config, uischema.options);

  const showDescription = true;

  const firstFormHelperText = showDescription ? description : !isValid ? errors : null;
  const secondFormHelperText = showDescription && !isValid ? errors : null;
  const InnerComponent = input;

  if (!visible || !isLevelEnabled(propertyLevel)) {
    return null;
  }

  return (
    <MantineInputWrapper
      id={id}
      label={label}
      required={showAsRequired(!!required, appliedUiSchemaOptions.hideRequiredAsterisk)}
      description={firstFormHelperText}
      error={secondFormHelperText}
    >
      <fieldset disabled={disabled}>
        <InnerComponent
          {...props}
          data={data ?? fallbackValue}
          id={id + '-input'}
          isValid={isValid}
          visible={visible}
        />
      </fieldset>
    </MantineInputWrapper>
  );
};
